export default __webpack_public_path__ + "static/media/facebook.d8e86339.svg";